import { Flex, Text, TextField, Tooltip, Icon } from "@wayflyer/flyui";
import type { ValueType as DataVizValueType } from "@wayflyer/flyui-dataviz";
import { styled } from "styled-components";
import { IconInfoCircle20Line } from "@wayflyer/flyui-icons/20/line";

export type ValueType = DataVizValueType;
export enum MetricReferenceDirection {
  UP = "UP",
  DOWN = "DOWN",
  SAME = "SAME",
}

export type AdditionalCostsData = {
  cogs: number;
  shipping: number;
  opex: number;
  marketing: number;
};

export interface InputProps {
  name: string;
  label: string;
  value: string | number;
  tooltip: string;
  unit?: string;
  handleOnChange: (event) => void;
}

interface InputLabelProps {
  label: string;
  tooltip: string;
}

export const Inp = ({ name, label, value, tooltip, handleOnChange }: InputProps) => {
  return (
    <div>
      <InpLabel label={label} tooltip={tooltip} />
      <TextField label={label} value={`${value}`} name={name} onChange={handleOnChange} />
    </div>
  );
};

const InputUnitContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const UnitContainer = styled.div`
  white-space: nowrap;
  padding-left: 5px;
  padding-bottom: 10px;
`;

const InputContainer = styled.div`
  display: flex;
  align-items: baseline;
`;

export const InputWithUnit = ({ label, tooltip, value, unit, handleOnChange }: InputProps) => {
  return (
    <InputUnitContainer>
      <InpLabel label={label} tooltip={tooltip} />
      <InputContainer>
        <TextField label={label} value={`${value}`} name={label} onChange={handleOnChange} />
        <UnitContainer>
          <Text>{unit}</Text>
        </UnitContainer>
      </InputContainer>
    </InputUnitContainer>
  );
};

const InpLabel = ({ label, tooltip }: InputLabelProps) => {
  return (
    <Flex wrap="nowrap" gap="1" align="center">
      <Text>{label}</Text>
      <Tooltip content={tooltip}>
        <Icon>
          <IconInfoCircle20Line />
        </Icon>
      </Tooltip>
    </Flex>
  );
};

export const Spacer = styled.span`
  margin: 30px;
`;
